import axios from "axios"

const LoginApi=async(formData, setIsError, setMessage)=>{
    try{
        const response = await axios.post("/api/login",formData);
        if (response.status===200){
        return response.data
        }
        else{
            setIsError(true);
            setMessage("An error occurred while logging in. Please try again later.");
            return false
        }
    }
    catch (error) {
        console.error("Error:", error.message);
        return null;
      }
    }
export default LoginApi;

// const LoginApi = async (formData, setIsError, setMessage) => {
//     try {
//       // Get user's current location
//       navigator.geolocation.getCurrentPosition(
//         async (position) => {
//           const { latitude, longitude } = position.coords;
  
//           // Add location to form data
//           formData.location = JSON.stringify({ latitude, longitude });
  
//           // Trigger Login and SaveLocation API calls simultaneously
//           const [loginResponse, locationResponse] = await Promise.all([
//             axios.post("/api/login/", formData),
//             axios.post("/api/save-location/", {
//               user_id: formData.user_id,
//               location: formData.location,
//             }),
//           ]);
  
//           if (loginResponse.status === 200 && locationResponse.status === 200) {
//             return loginResponse.data;
//           } else {
//             setIsError(true);
//             setMessage("An error occurred while logging in or saving location. Please try again later.");
//             return false;
//           }
//         },
//         (error) => {
//           console.error("Error getting location", error);
//           setIsError(true);
//           setMessage("Unable to retrieve your location. Please ensure location services are enabled.");
//           return false;
//         }
//       );
//     } catch (error) {
//       console.error("Error:", error.message);
//       return null;
//     }
//   };
  
//   export default LoginApi;


// const [user, setUser] = useState(() => {
//     if (localStorage.getItem("tokens")) {
//       let tokens = JSON.parse(localStorage.getItem("tokens"));
//       return jwt_decode(tokens.access_token);
//     }
//     return null;
//   });